import MainContentView from './mainContentView.jsx';

export default MainContentView;



// WEBPACK FOOTER //
// ./src/components/page/MainContent/index.js